<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-cascader v-model="formInline[item.key]"
    :placeholder="
      (item && item.options && item.options.placeholder) || '请选择'
    "
    :filterable="getValue(item, 'filterable', false)"
    :options="(item && item.optionsList) || []"
    :disabled="getValue(item, 'disabled', true)"
    :show-all-levels="getValue(item, 'allPath', true)"
    clearable
  ></el-cascader>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    formInline: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    defaultMaxLenght: 'defaultMaxLenght',
    colon: 'colon',
    customTypeList: 'customTypeList',
    getValue: 'getValue',
    placeholder: 'placeholder',
    selectPlaceholder: 'selectPlaceholder',
    customInputHandle: 'customInputHandle',
    telBlur: 'telBlur',
    numberMax: 'numberMax',
    changeSelect: 'changeSelect',
  },
  data() {
    return {
    }
  },
  watch: {
  },
}
</script>
